import { Component, Input, OnDestroy, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { updateDocumentState } from 'editor';
import { BehaviorSubject, Subject, combineLatest, filter, map, take, takeUntil, tap } from 'rxjs';
import * as ExportActions from '../../store/export.actions';
import { selectMetadata, selectTemplate } from '../../store/export.reducer';
import { DcaStore } from 'shared';

@Component({
  selector: 'sfo-export-settings',
  templateUrl: './export-settings.component.html',
  styleUrls: ['./export-settings.component.scss'],
  standalone: false,
})
export class ExportSettingsComponent implements OnDestroy {
  private store: Store = inject(Store);
  private dcaStore: DcaStore = inject(DcaStore);

  private destroy$ = new Subject<void>();
  private selectedUi$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  @Input() set selectedUi(value: string[]) {
    this.selectedUi$.next(value);
  }

  metaData$ = this.store.select(selectMetadata).pipe(
    take(1),
    map((metaData) => metaData),
    takeUntil(this.destroy$),
  );

  template$ = combineLatest([this.store.select(selectTemplate), this.selectedUi$]).pipe(
    filter(([template]) => !!template?.metaData),
    map(([template, uiRoleVisibility]) => this.filterConfigsByRole(template, uiRoleVisibility)),
    tap((template) => console.log('Filtered Template:', template)),
    takeUntil(this.destroy$),
  );

  ngOnDestroy(): void {
    this.dcaStore.collaspeDcaExpansion();
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateExportMetadata(form: object) {
    this.store.dispatch(ExportActions.updateMetadata({ metaData: form }));
    this.store.dispatch(updateDocumentState({ dirty: true }));
  }

  private filterConfigsByRole(template: any, uiRoleVisibility: string[]) {
    const _template = structuredClone(template);
    const metadata = _template?.['metaData'];

    for (const [key, property] of Object.entries(metadata.properties)) {
      if (property?.['ui']) {
        const uiShowTo = property['ui']['showTo'];

        if (Array.isArray(uiShowTo) && !uiShowTo.some((role) => uiRoleVisibility.includes(role))) {
          delete metadata.properties[key];
        }
      }
    }
    return _template;
  }
}
